export default function MarqueeBand() {
    return (
        <section className="marqueeSection">
            <div className="marquee">
                <div className="marqueeTrack">
                    {Array.from({ length: 12 }).map((_, i) => (
                        <span className="marqueeItem" key={`a-${i}`}>
                            SCALD COFFEE
                        </span>
                    ))}
                    {Array.from({ length: 12 }).map((_, i) => (
                        <span className="marqueeItem" key={`b-${i}`}>
                            SCALD COFFEE
                        </span>
                    ))}
                </div>
            </div>
        </section>
    );
}
